import type { UrlLocation } from '@seek/chalice-types';
import {
  parse as parseQueryString,
  stringify as stringifyQueryString,
} from 'query-string';

export const routerRequestToUrlLocation = (request: Request): UrlLocation => {
  const { hash, pathname, hostname, href, port, protocol, search } = new URL(
    request.url,
  );

  return {
    hash,
    hostname,
    href,
    pathname,
    port,
    protocol,
    query: parseQueryString(search),
  };
};

export const urlLocationToRouterRequest = (location: UrlLocation): Request => {
  const { hash, pathname, hostname, port, protocol, query } = location;
  const search =
    query && Object.keys(query).length ? `?${stringifyQueryString(query)}` : '';
  const host = port ? `${hostname}:${port}` : hostname;
  const hashValue = hash ? `#${hash}` : '';

  return new Request(`${protocol}//${host}${pathname}${search}${hashValue}`);
};
